import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AltraParte } from '../../../models/altraparte';

@Component({
    selector: '[add_doc_to_altraparte]',
  templateUrl: 'add-to-altraparte.component.html',
})

export class AddDocumentoToAltraParteComponent {
  @Input()
  altraParte: AltraParte;
  @Output()
  onClickAddToEntity = new EventEmitter();

  emitEntity(altraparte: AltraParte) {
    this.onClickAddToEntity.emit(altraparte);
  }
}
